
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ochrana-osobnych-udajov",
      function () {
        return require("private-next-pages/ochrana-osobnych-udajov.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ochrana-osobnych-udajov"])
      });
    }
  